import React, { useEffect, useRef, useState } from 'react'
import UploadFile from './UploadFile';
import Popup from 'reactjs-popup';
import SignaturePad from "react-signature-canvas";
import { useTranslate } from './TranslationText';
import NetaqInput from './NetaqInput';
import axios from '../axios/axios';
import Loader from './Loader';
import ActionButton from './ActionButton';
import FileUpload from './SimpleFileUpload';
import { getUserProfile } from '../helper/getUserProfile';
import dayjs from 'dayjs';
import axiosInstance from '../axios/axios';
import CustomSecondPopUp from './CustomSecondPopUp';
import EahsForm from './EahsForm';
import { eformInput } from '../common/cssclasses';

export default function UpgradeProfile({ toast, reloadProfile, setActiveTab }) {
    const { translate } = useTranslate();
    const signatureCanvas = useRef(null);
    const [imageURL, setImageURL] = useState(null);
    const [invalidIban, setInvalidIBAN] = useState(false);
    const onClearSignature = () => signatureCanvas.current.clear();
    const onSaveSignature = (onCloseSignaturePad) => {
        if (!signatureCanvas.current?.isEmpty()) {
            const imageData = signatureCanvas.current
                .getTrimmedCanvas()
                .toDataURL("image/png");
            setImageURL(imageData);
        }
    };
    const [hovered, setHovered] = useState({
        sign: false,
        close: false,
        clear: false,
        save: false,
        secondsignature: false,
    });
    const generateButtonStyle = (isHovered) => ({
        background: isHovered ? "#ffffff" : "#E44D52",
        padding: "10px 20px",
        color: isHovered ? "#E44D52" : "#fff",
        outline: 0,
        border: "solid",
        borderWidth: 1,
        borderColor: "#E44D52",
        transition: "all 0.3s",
        display: "block",
        margin: "auto",
        cursor: "pointer",
        borderRadius: 6
    });
    const buttonSubmitStyle = generateButtonStyle(hovered.sign);
    const handleMouseOver = (type) => {
        setHovered((prev) => ({ ...prev, [type]: true }));
    };

    const handleMouseOut = (type) => {
        setHovered((prev) => ({ ...prev, [type]: false }));
    };
    const handleSignitureFileChange = (e) => {
        let checkFileSize = true;
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                checkFileSize = false;
            } else {
                if (e.target.files && e.target.files.length > 0) {


                    var reader = new FileReader();
                    reader.readAsDataURL(e.target.files[0]);
                    reader.onload = function () {
                        setImageURL(reader.result);
                    };
                }
            }
        }

        if (!checkFileSize) {
            toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
        }
    };
    // onload functions
    useEffect(() => {
        getEmirateList();
        getNationalityList();
        getcurrencyList();
    }, [])

    // get dropdown lists options
    const [emiratelistoptions, setEmirateListOptions] = useState([]);
    const [regionsList, setRegionsList] = useState([]);
    const [nationalityOptions, setNationalityOptions] = useState([]);
    const [curenciesOptions, setCurenciesOptions] = useState([]);
    async function getEmirateList() {
        try {
            const emiratelist = await axios.get('/lookup/getmaincities')
            const formattedData = await emiratelist.data.result.map((item) => ({
                text: item.name,
                value: item.id,
            }));
            setEmirateListOptions(formattedData)
        } catch (error) {
            window.alert('error in emirates list')
        }

    }
    async function getRegionListbyID(id) {
        try {
            const regionList = await axios.get(`/lookup/getareasbyemirateid?EmirateId=${id}`)
            const formattedData = await regionList.data.result.map((item) => ({
                text: item.name,
                value: item.id,
            }));
            setRegionsList(formattedData)
        } catch (error) {
            window.alert('error in region list')
        }

    }
    // building submit form values
    async function getcurrencyList() {
        try {
            const currencylist = await axiosInstance.get('/lookup/getcurrencies')
            setCurenciesOptions(currencylist?.data?.result ?? []);
        } catch (error) {
            window.alert('error in currency list')
        }
    }
    async function getNationalityList() {
        try {
            const nationalityList = await axiosInstance.get('/nationality')
            const formattedData = await nationalityList.data.result.map((item) => ({
                text: item.name,
                value: item.id,
            }));
            setNationalityOptions(formattedData)
        } catch (error) {

        }

    }
    const fatherSigniture = useRef(null);
    const [birthDate, setBirthDate] = useState(null);
    const [isYoungerThan21, setIsYoungerThan21] = useState(false);
    const [fatherHasAccount, setFatherHasAccount] = useState(true);
    const [fatherImageUrl, setFatherImageURL] = useState(null)
    const [issubmitting, setIsSubmitting] = useState(false);
    const [parentPassPortOrNationaIdFile, setParentPassPortOrNationaIdFile] = useState([]);
    const [upgradeDetails, setUpgradeDetails] = useState({
        'user-type': 2,
        bankName: '',
        iban: '',
        swiftCode: '',
        bneficiaryName: '',
        bankCountry:
        {
            text: translate("web.chooseBankCountry", "Choose Bank Country"),
            label: translate("web.chooseBankCountry", "Choose Bank Country"),
            value: null,
        },
        currncy: {
            text: translate("web.curency", "Curency"),
            label: translate("web.curency", "Curency"),
            value: null,
        }
    });

    useEffect(() => {
        if (((upgradeDetails.iban?.length < 14 || upgradeDetails.iban?.length > 35) && (upgradeDetails?.iban.length > 0)) ?? false) {
            setInvalidIBAN(true);
        } else {
            setInvalidIBAN(false);
        }
    }, [upgradeDetails.iban]);
    // handlechange
    const handleChange = (event, input, index = 0) => {
        if (!!input && input === "selectedemiret") {
            getRegionListbyID(event.value);
            setUpgradeDetails((prevUpgradeDetails) => ({
                ...prevUpgradeDetails,
                selectedemirateId: event.value,
                selectedemirateIdDrop: event,
                selectedregionDrop: null
            }));
            return;
        }
        if (!!input && input === "bankCountry") {
            setUpgradeDetails((prevUpgradeDetails) => ({
                ...prevUpgradeDetails,
                bankCountry: event
            }));
            return;
        }
        if (!!input && input === "currency") {
            setUpgradeDetails((prevUpgradeDetails) => ({
                ...prevUpgradeDetails,
                currncy: event
            }));
            return;
        }
        if (!!input && input === "region") {
            setUpgradeDetails((prevUpgradeDetails) => ({
                ...prevUpgradeDetails,
                selectedregion: event.value,
                selectedregionDrop: event,
            }));
            return;
        }
        setUpgradeDetails((prevUpgradeDetails) => ({
            ...prevUpgradeDetails,
            [event.target.name]: event.target.value,
        }));
    };
    const handleFatherRadioChange = (event) => {
        if (event.target.value == 'true') {
            setFatherHasAccount(true);
        } else {
            setFatherHasAccount(false);
        }
    }
    const onFatherSaveSignature = (onCloseSignaturePad) => {
        if (!fatherSigniture.current?.isEmpty()) {
            const imageData = fatherSigniture.current
                .getTrimmedCanvas()
                .toDataURL("image/png");
            setFatherImageURL(imageData);
        }
    };
    const onFatherClearSignature = () => fatherSigniture.current.clear();
    const handleFatherFileChange = (e) => {
        let checkFileSize = true;
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                checkFileSize = false;
            } else {
                if (e.target.files && e.target.files.length > 0) {


                    var reader = new FileReader();
                    reader.readAsDataURL(e.target.files[0]);
                    reader.onload = function () {
                        setFatherImageURL(reader.result);
                    };
                }
            }
        }

        if (!checkFileSize) {
            toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
        }
    };
    const parentNationaIdFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }

            setParentPassPortOrNationaIdFile(fileListHook);
        }
    };

    // handle submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        const errors = [];

        if (!birthDate) {
            errors.push(translate('web.birthDateRequired', 'Birth date is required'));
        }

        if (upgradeDetails['user-type'] == 2) {
            if (!upgradeDetails.selectedemirateIdDrop) {
                errors.push(translate('web.chooseEmirateRequired', 'Choose Emirate is required'));
            }
            if (!upgradeDetails.selectedregionDrop) {
                errors.push(translate('web.chooseRegionRequired', 'Choose Region is required'));
            }
            if (isYoungerThan21 && !fatherHasAccount && parentPassPortOrNationaIdFile.length <= 0) {
                errors.push(translate('web.pleaseUploadYourFatherId', 'Please Upload Your Father ID'));
            }
            if (!imageURL) {
                errors.push(translate('web.pleaseUploadSigniture', 'Please Upload Your Signiture'));
            }
            // Add more checks for other required fields if necessary
        } else {
            if (!upgradeDetails?.bankCountry?.value ?? true) {
                errors.push(translate('web.bankCountryIsRequired', 'Bank Country Is Required'));
            }
            if (!upgradeDetails?.currncy?.value ?? true) {
                errors.push(translate('web.currencyIsRequired', 'Currency Is Required'));
            }
            if (!upgradeDetails?.bankName ?? true) {
                errors.push(translate('web.bankNameIsRequired', 'Bank Name Is Required'));
            }
            if (!upgradeDetails?.bneficiaryName ?? true) {
                errors.push(translate('web.bneficiaryNameIsRequired', 'BeneficiaryName Is Required'));
            }
            if (!upgradeDetails?.swiftCode ?? true) {
                errors.push(translate('web.swiftCodeIsRequired', 'Swift Code Is Required'));
            }
            if (!upgradeDetails?.iban ?? true) {
                errors.push(translate('web.ibanIsRequired', 'IBAN Code Is Required'));
            }
        }

        if (errors.length > 0) {
            errors.forEach(error => toast.error(error));
            setIsSubmitting(false);
            return;
        }

        try {
            const upgradeNow = await axios.post('account/upgradeaccount', {
                Signture: imageURL,
                AccountType: upgradeDetails['user-type'],
                UpgradeStatus: upgradeDetails['user-type'] == 2 ? 1 : 2,
                ParentPassPortOrNationaIdFile: parentPassPortOrNationaIdFile[0] ?? '',
                ParentAccountRegNo: upgradeDetails.ParentAccountRegNo ?? '',
                ParentSignture: fatherImageUrl ?? '',
                EmirateId: upgradeDetails.selectedemirateId ?? '',
                AreaId: upgradeDetails.selectedregion ?? '',
                BirthDate: birthDate ?? '',
                Iban: upgradeDetails.iban,
                BankName: upgradeDetails.bankName,
                BneficiaryName: upgradeDetails.bneficiaryName,
                CurrencyId: upgradeDetails.currncy?.value ?? '',
                BankCountryId: upgradeDetails.bankCountry?.value ?? '',
                SwiftCode: upgradeDetails.swiftCode
            }, {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            })

            if (upgradeNow.data.responseCode == '200') {
                setIsSubmitting(false);
                toast.success('web.upgradeRequestSuccess', 'Your Request is sent seceefully')
                const updateuserProfile = await getUserProfile();
                if (updateuserProfile) {
                    setActiveTab('accountSetting')
                    reloadProfile();

                }
            } else {
                setIsSubmitting(false);
                toast.error('web.error', 'An Error In Upgrade Account')

            }

        } catch (error) {
            console.log('error in upgrade', error)
            setIsSubmitting(false);
        }





    }

    return (
        <EahsForm title={translate('web.upgradeTo', 'Upgrade To')} isform onSubmit={handleSubmit}>
            <div className={eformInput + ' tooltip'}>
                <span class="tooltiptext">{translate('web.localOwnerToolTip', 'If You Have Are In UAE And You Have Hourses Not Registerd In EAHS')}</span>
                <NetaqInput
                    type={"radio"}
                    name={"user-type"}
                    label={translate('web.localOwner', 'Local Owner')}
                    value={2}
                    checked={true}
                    onChange={handleChange}
                />
            </div>
            <div className={eformInput + ' tooltip'}>
                <span class="tooltiptext">{translate('web.internationalOwnerToolTip', 'If You have Hourses OutSide UAE And NOT without Regstration Number')}</span>
                <NetaqInput
                    type={"radio"}
                    name={"user-type"}
                    label={translate('web.internationalOwner', 'International Owner')}
                    value={3}
                    onChange={handleChange}
                />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"date"}
                    label={translate('web.birthDate', "Birth Date")}
                    name={"birthdate"}
                    maxDate={dayjs()}
                    required={true}
                    onChange={(e) => {
                        let now = new Date();
                        now.setHours(0, 0, 0, 0);
                        now.setFullYear(now.getFullYear() - 21);
                        setIsYoungerThan21(e.isAfter(now));
                        setBirthDate(e.toDate())
                    }}
                />
            </div>
            {upgradeDetails['user-type'] == 2 &&
                <>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"select"}
                            label={translate("web.chooseEmirate", "Choose Emirate")}
                            placeholder={translate("web.chooseEmirate", "Choose Emirate")}
                            name={"selectedemiret"}
                            listSelect={emiratelistoptions}
                            value={upgradeDetails.selectedemirateIdDrop}
                            onChange={(evt) => handleChange(evt, "selectedemiret")}
                            required={true}
                        />
                    </div>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"select"}
                            label={translate("web.chooseRegion", "Choose Region")}
                            placeholder={translate("web.chooseRegion", "Choose Region")}
                            name={"region"}
                            listSelect={regionsList}
                            value={upgradeDetails.selectedregionDrop}
                            onChange={(evt) => handleChange(evt, "region")}
                            required={true}
                        />
                    </div>
                    <div className={eformInput}>
                        <label> {translate('web.yourSigniture', 'Your signature')}<span className='color-eahsred ms-1'>*</span></label>
                        <div className="row">
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-start",
                                    alignContent: "center",
                                    alignItems: 'center',
                                    flexWrap: "wrap"
                                }}
                            >
                                <CustomSecondPopUp
                                    overlayStyle={{ zIndex: 5000 }}
                                    modal
                                    lockScroll
                                    trigger={
                                        <div
                                            style={{
                                                display: "flex",
                                            }}
                                        >
                                            <span
                                                style={buttonSubmitStyle}
                                                onMouseOver={() => handleMouseOver("sign")}
                                                onMouseOut={() => handleMouseOut("sign")}
                                            >
                                                {translate('web.openSigniturePad', 'Open Signiture Pad')}
                                            </span>
                                        </div>
                                    }
                                    onSave={onSaveSignature}
                                    onClear={onClearSignature}
                                >
                                    <SignaturePad
                                        ref={signatureCanvas}
                                        canvasProps={{
                                            className: "signatureCanvas",
                                        }}
                                    />
                                </CustomSecondPopUp>
                                <span style={{ margin: 'auto 5px' }} className="uaepassor">
                                    {translate("web.or", "OR")}
                                </span>
                                <UploadFile
                                    text="Upload Singniture Photo"
                                    onChange={handleSignitureFileChange}
                                />
                                {imageURL ? (
                                    <img
                                        className='my-2 mx-auto'
                                        src={imageURL}
                                        alt="Owner Signature"
                                        style={{
                                            width: "100%",
                                            maxWidth: 200,
                                            maxHeight: 50,
                                            marginLeft: 15,
                                        }}
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                </>
            }
             {isYoungerThan21 === true && upgradeDetails['user-type'] == 2 &&
                <>
                    <label className="">
                        {translate('web.doYourFatherHaveAnAccountOnOurSystem', 'Do Your Father Have An Account On Our System?')}
                    </label>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"radio"}
                            label={translate("web.yes", "Yes")}
                            name={'fatherHasAccount'}
                            onChange={handleFatherRadioChange}
                            value={true}
                            checked={true}
                        />
                    </div>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"radio"}
                            label={translate("web.no", "No")}
                            name={'fatherHasAccount'}
                            value={false}
                            onChange={handleFatherRadioChange}
                        />
                    </div>

                    {fatherHasAccount == true &&
                        <div className={eformInput}>
                            <NetaqInput
                                type={"text"}
                                label={translate("web.yourFatherRegNumber", "Your Father Reg. Number")}
                                placeholder={translate("web.yourFatherRegNumber", "Your Father Reg. Number")}
                                name={"ParentAccountRegNo"}
                                onChange={handleChange}
                                required={true}
                            />
                        </div>
                    }
                    {
                        fatherHasAccount == false &&
                        <>
                            <div className={eformInput}>
                                <label className=''>{translate('web.yourFathersignature', 'Your Father signature')} *</label>
                                <div className="" >
                                    <div className="">
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "flex-start",
                                                alignContent: "center",
                                                alignItems: 'center',
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            <CustomSecondPopUp
                                                trigger={
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <span
                                                            style={buttonSubmitStyle}
                                                            onMouseOver={() => handleMouseOver("sign")}
                                                            onMouseOut={() => handleMouseOut("sign")}
                                                        >
                                                            {translate('web.openSigniturePad', 'Open Signiture Pad')}
                                                        </span>
                                                    </div>
                                                }
                                                onSave={onFatherSaveSignature}
                                                onClear={onFatherClearSignature}
                                            >
                                                <SignaturePad
                                                    ref={fatherSigniture}
                                                    canvasProps={{
                                                        className: "signatureCanvas",
                                                    }}
                                                />
                                            </CustomSecondPopUp>
                                            <span style={{ margin: 'auto 5px' }} className="uaepassor">
                                                {translate("web.or", "OR")}
                                            </span>

                                            <UploadFile
                                                text={translate("web.uploadSingniturePhoto", "Upload Singniture Photo")}
                                                onChange={handleFatherFileChange}
                                            />

                                            {fatherImageUrl ? (
                                                <img
                                                    className='my-2'
                                                    src={fatherImageUrl}
                                                    alt="Owner Signature"
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: 200,
                                                        maxHeight: 50,
                                                        marginLeft: 15,
                                                    }}
                                                />
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={eformInput}>
                                <label >
                                    {translate('web.yourFatherID', 'Your FatherID  Copy')} <span className='color-eahsred' >*</span>
                                </label>
                                <FileUpload showToastMsg={toast}
                                    multiple={false} key={'ID UPLOAD'} initialFiles={parentPassPortOrNationaIdFile} isMulti={false} isServer={false} required={true} onChange={parentNationaIdFile} />
                            </div>
                        </>
                    }
                </>
            }
            <h6 className='fw-bold mt-1'>{translate('web.bankDetails', 'Bank Details')}</h6>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    label={translate("web.bankName", "Bank Name")}
                    placeholder={translate("web.bankName", "Bank Name")}
                    name={"bankName"}
                    onChange={handleChange}
                    required={upgradeDetails['user-type'] == 3}
                />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    label={translate("web.bneficiaryName", "Bneficiary Name")}
                    placeholder={translate("web.bneficiaryName", "Bneficiary Name")}
                    name={"bneficiaryName"}
                    onChange={handleChange}
                    required={upgradeDetails['user-type'] == 3}
                />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    label={translate("web.iban", "IBAN")}
                    placeholder={translate("web.iban", "Iban")}
                    name={"iban"}
                    key={"IBAN"}
                    onChange={handleChange}
                    required={upgradeDetails['user-type'] == 3}
                />
                {invalidIban &&
                    <div className='text-danger text-center'>
                        {translate('web.invalidIban', 'Invalid IBAN')}
                    </div>
                }
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    label={translate("web.swiftCode", "Swift Code")}
                    placeholder={translate("web.swiftCode", "Swift Code")}
                    name={"swiftCode"}
                    onChange={handleChange}
                    required={upgradeDetails['user-type'] == 3}
                />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"select"}
                    label={translate("web.bankCountry", "Bank Country")}
                    placeholder={translate("web.bankCountry", "Bank Country")}
                    name={"bankCountryId"}
                    listSelect={nationalityOptions}
                    value={upgradeDetails.bankCountry}
                    onChange={(evt) => handleChange(evt, "bankCountry")}
                    required={upgradeDetails['user-type'] == 3}

                />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"select"}
                    label={translate("web.curency", "Curency")}
                    placeholder={translate("web.curency", "curency")}
                    name={"currencyId"}
                    listSelect={curenciesOptions}
                    value={upgradeDetails.currncy}
                    onChange={(evt) => handleChange(evt, "currency")}
                    required={upgradeDetails['user-type'] == 3}

                />
            </div>
           

            {upgradeDetails['user-type'] == 3 && <div className='col-lg-12 col-md-12 col-sm-12'>
                <label> {translate('web.yourSigniture', 'Your signature')} ({translate('web.optional', 'Optional')})  </label>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignContent: "center",
                                alignItems: 'center'
                            }}
                        >
                            <CustomSecondPopUp
                                trigger={
                                    <div
                                        style={{
                                            display: "flex",
                                        }}
                                    >
                                        <span
                                            style={buttonSubmitStyle}
                                            onMouseOver={() => handleMouseOver("sign")}
                                            onMouseOut={() => handleMouseOut("sign")}
                                        >
                                            {translate('web.openSigniturePad', 'Open Signiture Pad')}
                                        </span>
                                    </div>
                                }
                                onSave={onSaveSignature}
                                onClear={onClearSignature}
                            >
                                <SignaturePad
                                    ref={signatureCanvas}
                                    canvasProps={{
                                        className: "signatureCanvas",
                                    }}
                                />
                            </CustomSecondPopUp>
                            <span style={{ margin: 'auto 5px' }} className="uaepassor">
                                {translate("web.or", "OR")}
                            </span>
                            <UploadFile
                                text="Upload Singniture Photo"
                                onChange={handleSignitureFileChange}
                            />
                            {imageURL ? (
                                <img
                                    src={imageURL}
                                    alt="Owner Signature"
                                    style={{
                                        width: "100%",
                                        maxWidth: 200,
                                        maxHeight: 50,
                                        marginLeft: 15,
                                    }}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>}
            {!!issubmitting ?
                <div className='col-lg-12 col-md-12 col-sm-12'>
                    <Loader />
                </div>
                :
                <div className='col-lg-12 col-md-12 col-sm-12 pt-3'>
                    <ActionButton
                        width={100}
                        key={"Upgrade"}
                        text={translate("web.upgrade", "Upgrade")}
                        type={"submit"}
                    />
                </div>
            }
        </EahsForm>
    )
}
